import React, {useState} from 'react';
import { toast } from 'react-toastify';
import {GoLocation} from 'react-icons/go';
import {AiOutlinePhone, AiOutlineMail} from 'react-icons/ai';
import { Global } from '../Variables/Global';

const ContactAR = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        fetch(Global.API_URL + "ContactUs/ContactUsAR", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": Global.API_URL,
            },
            body: JSON.stringify({
                Name: name,
                Email: email,
                PhoneNumber: phone,
                Message: message
            }),
        }).then((Response) => {
            if (Response.ok) return Response.json();
            else throw Error("Did Not Receive expected data");
            }).then(res => {
                toast.success("تم ارسال الرسالة بنجاح");
            })
    }
    return (
        <>
            {/* <HeaderAR /> */}
            <div className="breadcrumb-area mb-50 ">
                <div className="container ">
                    <div className="row ">
                        <div className="col ">
                            <div className="breadcrumb-container  d-flex flex-row-reverse   ">
                                <div className="breadcrumbArabic  HomeShop">
                                    <ul>
                                        <li className="active">تواصل معنا</li>
                                        <li><a style={{direction: 'rtl'}} href="index.html"><i className="fa fa-home"></i>
                                            المنزل</a></li>


                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-content mb-50 mt-5">

                
                {/* <div className="google-map-container mb-70">
                    
                    <iframe className="map-size"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3612.435640639476!2d56.332063454138755!3d25.120958579217493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef4f9dbea9bfe93%3A0x43f53513dc20f051!2sOSSA%20KBIRE!5e0!3m2!1sen!2slb!4v1677052805802!5m2!1sen!2slb"
                        width="600" height="450" style={{border: '0'}} allowFullScreen="" loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div> */}


                <div className="container">
                    <div className="row">
                        <div className="col-lg-9 col-md-8 pl-100 pl-xs-15">

                            <div className="contact-form-content">
                                {/* <h3 className="contact-page-title d-flex flex-row-reverse">رسائل</h3> */}

                                <div className="contact-form">
                                    <form method="post" onSubmit={handleSubmit}>
                                        <div className="form-group ">
                                            <div className="d-flex flex-row-reverse"><label>الإسم<span
                                                className="required">*</span></label></div>

                                            <input className='directionRtlInput' type="text" name="customerName" id="customername" required onChange={(e) => setName(e.target.value)} />
                                        </div>
                                        <div className="form-group">
                                            <div className="d-flex flex-row-reverse"><label>البريد الإلكتروني <span
                                                className="required">*</span></label></div>
                                            <input className='directionRtlInput' type="email" name="customerEmail" id="customerEmail" required  onChange={(e) => setEmail(e.target.value)} />
                                        </div>
                                        {/* <div className="form-group">
                                            <div className="d-flex flex-row-reverse"><label>الموضوع <span
                                                className="required">*</span></label></div>
                                            <input type="text" name="contactSubject" id="contactSubject" />
                                        </div> */}
                                           <div className="form-group">
                                            <label className='directionRtl'>رقم الهاتف:</label>
                                            <input className='directionRtlInput' type="text" name="contactNumber" placeholder='رقم الهاتف' id="contactNumber" onChange={(e) => setPhone(e.target.value)} />
                                        </div>
                                        <div className="form-group ">
                                            <div className="d-flex flex-row-reverse"><label>الرسالة<span
                                                className="required">*</span></label></div>
                                            <textarea className='directionRtlInput' name="contactMessage" id="contactMessage" onChange={(e) => setMessage(e.target.value)}></textarea>
                                        </div>
                                        <div className="form-group d-flex flex-row-reverse mb-5">
                                            <button type="submit" value="submit" id="submit" className="contact-form-btn"
                                                name="submit">أرسل</button>
                                        </div>
                                    </form>
                                </div>
                                <p className="form-messege pt-10 pb-10 mt-10 mb-10"></p>
                            </div>

                        </div>
                        <div className="col-lg-3 col-md-4 mb-xs-35">

                            <div className="contact-page-side-content ">
                                <h3 className="contact-page-title d-flex flex-row-reverse">تواصل معنا</h3>


                                <div className="single-contact-block">
                                    <div className="d-flex flex-row-reverse">
                                        <h4><GoLocation /> العنوان </h4>
                                    </div>
                                    <div className="float-sm-end">
                                        <p className="directionRtl">دبي – الإمارات العربية المتحدة</p>
                                    </div>


                                </div>



                                <div className="single-contact-block  ">

                                    <div className="d-flex flex-row-reverse">
                                        {/* <h4><img width="36" height="40" src={ContactIcon2} alt="" />
                                            الهاتف
                                        </h4> */}
                                        <h4><AiOutlinePhone /> الهاتف</h4>
                                    </div>

                                    <div className="float-sm-end">
                                        <p>+971 58 206 0373 </p>
                                    </div>


                                </div>



                                <div className="single-contact-block">
                                    <div className="d-flex flex-row-reverse">
                                        {/* <h4><img width="38" height="42" src={ContactIcon3} alt="" />
                                            البريد الإلكتروني
                                        </h4> */}
                                        <h4><AiOutlineMail /> البريد الإلكتروني</h4>
                                    </div>



                                    <div className="float-sm-end">
                                        <p className="directionRtl">info@ossakbire.com</p>
                                    </div>
                                </div>




                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/* <FooterAR /> */}
        </>
    )
}

export default ContactAR